<div>
  <form [formGroup]="formGroup" class="text-sm" *ngIf="formGroup" (ngSubmit)="submitForm()">
    <div *ngIf="!userId">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
        <div [ngClass]="formGroup.controls['name'].touched ? (formGroup.controls['name'].errors ? 'has-error' : 'has-success') : ''">
          <label for="name">{{ "users_page.name" | translate }}</label>
          <input id="name" type="text" placeholder="{{ 'users_page.enter_name' | translate }}" class="form-input" formControlName="name" />
          <small class="text-danger" *ngIf="formGroup.controls['name'].errors && formGroup.controls['name'].touched">
            {{ "users_page.please_provide_name" | translate }}
          </small>
        </div>

        <div [ngClass]="formGroup.controls['surname'].touched ? (formGroup.controls['surname'].errors ? 'has-error' : 'has-success') : ''">
          <label for="surname">{{ "users_page.surname" | translate }}</label>
          <input id="surname" type="text" placeholder="{{ 'users_page.enter_surname' | translate }}" class="form-input" formControlName="surname" />
          <small class="text-danger" *ngIf="formGroup.controls['surname'].errors && formGroup.controls['surname'].touched">
            {{ "users_page.please_provide_surname" | translate }}
          </small>
        </div>
      </div>

      <div class="mb-5" [ngClass]="formGroup.controls['email'].touched ? (formGroup.controls['email'].errors ? 'has-error' : 'has-success') : ''">
        <label for="email">{{ "users_page.email" | translate }}</label>
        <input id="email" type="text" placeholder="{{ 'users_page.enter_email' | translate }}" class="form-input" formControlName="email" />
        <small class="text-danger" *ngIf="formGroup.controls['email'].errors && formGroup.controls['email'].touched">
          {{ "users_page.please_provide_email" | translate }}
        </small>
      </div>

      <div class="mb-5" [ngClass]="formGroup.controls['password'].touched ? (formGroup.controls['password'].errors ? 'has-error' : 'has-success') : ''">
        <label for="password">{{ "users_page.password" | translate }}</label>
        <input id="password" type="password" placeholder="{{ 'users_page.enter_password' | translate }}" class="form-input" formControlName="password" />
        <div *ngIf="formGroup.controls['password'].invalid && (formGroup.controls['password'].dirty || formGroup.controls['password'].touched)">
          <small class="text-danger" *ngIf="formGroup.controls['password'].errors?.['required']">{{ "enter_valid_password" | translate }}</small>
          <small class="text-danger" *ngIf="formGroup.controls['password'].errors?.['invalidPassword']">{{ "password_must_be_at_least_6_characters" | translate }}</small>
        </div>
      </div>
    </div>

    <div class="mb-5" [ngClass]="formGroup.controls['role'].touched ? (formGroup.controls['role'].errors ? 'has-error' : 'has-success') : ''">
      <label for="role">{{ "users_page.role" | translate }}</label>
      <ng-select
        labelForId="role"
        formControlName="role"
        [items]="options"
        [searchable]="false"
        [clearable]="false"
        bindLabel="label"
        bindValue="value"
        class="custom-multiselect"
        placeholder="{{ 'users_page.enter_role' | translate }}"
        [tabFocusOnClearButton]="false"
        [appendTo]="'body'"
      >
      </ng-select>
      <small class="text-danger" *ngIf="formGroup.controls['role'].errors && formGroup.controls['role'].touched">
        {{ "users_page.please_provide_role" | translate }}
      </small>
    </div>

    <button type="submit" class="btn btn-primary w-full" [disabled]="isLoading">
      <ng-container *ngIf="isLoading; else alternateTranslation">
        <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
        {{ "loading" | translate }}
      </ng-container>
      <ng-template #alternateTranslation>
        <span *ngIf="!userId">{{ "create_label" | translate }}</span>
        <span *ngIf="userId">{{ "save" | translate }}</span>
      </ng-template>
    </button>
  </form>
</div>
